import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// import Routings from "./Routes/Routings";
import { ConfigProvider } from "antd";
import "react-phone-number-input/style.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { SocketContextProvider } from "./context/SocketContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#176B53",
      },
    }}
  >
    <Provider store={store}>
      <SocketContextProvider>
        <App />
      </SocketContextProvider>
    </Provider>    
  </ConfigProvider>
);